import {Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {EMPTY, catchError, finalize, first, switchMap, tap, map} from 'rxjs';
import { CustomerFormService } from '@frontend/forms';
import { CustomerService, PropertyService, ThemeService } from '@frontend/services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Customer, PropertyOverviewAgent } from '@frontend/models';
import {TranslationService} from "../../i18n/TranslationService";

@Component({
  selector: 'new-offer',
  templateUrl: 'new-offer.component.html',
  styleUrls: ['new-offer.component.scss'],
})
export class NewOfferComponent implements OnInit {
  objectId = this._route.snapshot.paramMap.get('objectId') ?? '';
  agent!: PropertyOverviewAgent;
  overview$ = this._propertyService.getPublicPropertyOverview$(this.objectId);

  customerForm = this._customerFormService.createCustomerFormGroup();
  loading = false;

  themeLogoUrl$ = this._themeService.currentThemeLogoUrl$;

  constructor(
    private _route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private _router: Router,
    private _customerFormService: CustomerFormService,
    private _customerService: CustomerService,
    private _propertyService: PropertyService,
    private _themeService: ThemeService,
    private _translationService: TranslationService,
  ) { }

  ngOnInit() {
    this.agent = this._route.snapshot.data['agent'];
    this._themeService.setCustomerPortalLanguage(this.agent);
  }

  openOffer() {
    if (this.customerForm.invalid) {
      console.warn('Form Invalid!');
      this.customerForm.markAsDirty();
      this.customerForm.markAllAsTouched();

      return;
    }

    const customerData = this.customerForm.value;

    this.loading = true;

    this._customerService.saveCustomerDetails$(customerData, this.agent.id).pipe(
      first(),
      catchError(() => {
        const message = this._translationService.instant('alerts.retry');
        const action = this._translationService.instant('alerts.close');
        this._snackBar.open(message, action);
        return EMPTY;
      }),
      switchMap((customer: Customer) => this._propertyService.createCustomerPortal$(this.objectId, customer.id, customer?.contact?.email || 'no-reply@propup.at')),
      tap((result) => {
        if (!result?.id) {
          throw new Error('No result');
        }

        this._router.navigate(['overview', result.id])

      }),
      catchError(() => {
        const message = this._translationService.instant('alerts.retry');
        const action = this._translationService.instant('alerts.close');
        this._snackBar.open(message, action);
        return EMPTY;
      }),
      finalize(() => this.loading = false),
    ).subscribe();
  }
}